import React from 'react';
import { Image } from '@qga/roo-ui/components';

import holiday from './assets/Holiday.svg';

const HolidaysIcon = () => <Image src={holiday} alt="holiday package icon" />;

export default HolidaysIcon;
